module.exports = __webpack_public_path__ + "static/media/boshidun2.12760572.png";